import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import { Form, Button } from 'react-bootstrap';
import {
   FaFax,
   FaRegEnvelope,
   FaPhoneAlt,
   FaMapMarker,
   FaFacebook,
   FaFacebookSquare,
   FaTwitter,
   FaLinkedin,
   FaYoutube,
   FaInstagram,
} from 'react-icons/fa';
import { FaSquareXTwitter } from 'react-icons/fa6';
import Logo from '../assets/images/itc.png';
import { toast } from 'react-toastify';
import authService from '../services/Auth';
import { Link, useNavigate } from 'react-router-dom';

const Footer = () => {
   const navigate = useNavigate();
   const [value, setValue] = useState({
      name: '',
      email: '',
      message: '',
   });
   const year = new Date().getFullYear('YYYY');

   const handleClick = async (e) => {
      try {
         let payload = value;
         const response = await authService.feedback(payload);
         if (response.status === 201) {
            navigate('/user/mybooking');
            toast('Successfully sent feedback message', {
               position: 'top-right',
               autoClose: 1000,
            });
         } else {
            toast.error(response?.data?.error ?? 'Unable to send message!');
         }
      } catch (error) {
         toast.error('Something went wrong.');
      }
   };

   const onChange = (e) => {
      setValue({ ...value, [e.target.name]: e.target.value });
   };

   return (
      <div className="footer pt-16 pb-4 border-none">
         <Container fluid="sm">
            <div className="m-auto flex-wrap mt-20 flex justify-between pb-32 items-center">
               <div className="lg:w-8/12 md:w-8/12 sm:w-8/12 w-full !drop-shadow-xl">
                  <h1 className="lg:text-[78px] md:text-5xl text-3xl lg:w-6/12 md:w-6/12 sm:w-6/12  font-semibold tracking-tight text-black sm:text-4xl">
                     We’d Love To Hear From You !!
                  </h1>
                  {/* <h2 className="text-5xl w-4/12 font-bold tracking-tight text-[#001D47] sm:text-4xl">
                  from you
                  </h2> */}
               </div>
               <div className="lg:w-4/12 md:w-4/12 sm:w-4/12 w-full">
                  <input
                     type="text"
                     required
                     className="w-full  border-b border-slate-400 bg-white/5 px-3.5 py-2 mb-3 text-black text-base leading-6"
                     placeholder="Your Name"
                     name="name"
                     onChange={onChange}
                  />
                  <input
                     type="email"
                     required
                     className="w-full  border-b border-slate-400 bg-white/5 px-3.5 py-2 mb-3 text-black text-base leading-6"
                     placeholder="Your Email Address"
                     name="email"
                     onChange={onChange}
                  />
                  <textarea
                     placeholder="Your Message"
                     className="w-full  border-b border-slate-400 bg-white/5 px-3.5 py-2 mb-3 text-black text-base leading-6"
                     name="message"
                     onChange={onChange}
                  />
                  <button
                     onClick={handleClick}
                     className="flex ml-auto rounded-md bg-[#0168FF] px-4 py-2.5  font-semibold font-quicksand text-base text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
                  >
                     Submit
                  </button>
               </div>
            </div>
            <div className="m-auto flex-wrap mt-20 flex justify-between items-center">
               <div className=" mb-4">
                  <img className="w-full h-32" src={Logo} />
               </div>
               <div>
                  <div className="flex items-center mb-4">
                     <FaMapMarker
                        style={{
                           color: '#0168FF',
                           fontSize: '18px',
                           marginRight: 8,
                        }}
                     />
                     <h3 className="font-semibold font-quicksand text-base text-[#0A142F]">
                        7 Bayview Station Rd, Box #78 Ottawa, ON K1Y 2C5 Box
                     </h3>
                  </div>
                  <div className="flex items-center justify-between">
                     <div className="flex items-center mb-4">
                        <FaPhoneAlt
                           style={{
                              color: '#0168FF',
                              fontSize: '18px',
                              marginRight: 8,
                           }}
                        />
                        <h3 className="font-semibold font-quicksand text-base text-[#0A142F]">
                           613-902-8115
                        </h3>
                     </div>
                     {/* <div className="flex items-center mb-4">
                        <FaFax
                           style={{
                              color: '#0168FF',
                              fontSize: '18px',
                              marginRight: 8,
                           }}
                        />
                        <h3 className="font-normal text-sm text-[#0A142F]">
                           613-902-8115
                        </h3>
                     </div> */}
                  </div>
                  <div className="flex items-center">
                     <div className="w-4/12">
                        <h3 className="font-semibold text-base font-quicksand text-[#0A142F]">
                           Social Media
                        </h3>
                     </div>
                     <div className="flex justify-between w-8/12 items-center">
                        {/* <div className="h-8 w-8 rounded-full bg-black flex justify-center items-center"> */}
                        <a
                           href="https://www.facebook.com/InspectThisCar?mibextid=ZbWKwL"
                           target="_blank"
                        >
                           <FaFacebookSquare
                              style={{
                                 // color: '#0168FF',
                                 color: '#1877F2',
                                 // color: 'white',
                                 fontSize: '25px',
                                 // marginRight: 8,
                              }}
                              className="facebook transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:duration-300"
                           />
                        </a>
                        {/* </div> */}

                        {/* <div className="h-8 w-8 rounded-full bg-black flex justify-center items-center"> */}
                        <a
                           href="https://www.linkedin.com/company/inspectthiscar-com/"
                           target="_blank"
                        >
                           <FaLinkedin
                              style={{
                                 color: '#0077B5',
                                 // color: 'white',
                                 fontSize: '25px',
                                 // marginRight: 8,
                              }}
                              className="linkedin transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:duration-300"
                           />
                        </a>
                        {/* </div> */}

                        {/* <div className="h-8 w-8 rounded-full bg-black flex justify-center items-center"> */}
                        <a
                           href="https://youtu.be/4uNuXhXlcbY?si=Z5VrrBjHxt-5RclL"
                           target="_blank"
                        >
                           <FaYoutube
                              style={{
                                 color: '	#FF0000',
                                 // color: 'white',
                                 fontSize: '25px',
                                 // marginRight: 8,
                              }}
                              className="youtube transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:duration-300 "
                           />
                        </a>
                        {/* </div> */}

                        {/* <div className="h-8 w-8 rounded-full bg-black flex justify-center items-center"> */}
                        <a
                           href="https://www.instagram.com/inspectthiscar?igsh=MWJ2ajY4MjViNDduag%3D%3D"
                           target="_blank"
                        >
                           <FaInstagram
                              style={{
                                 color: '#e56969',
                                 // color: 'white',
                                 fontSize: '25px',
                                 // marginRight: 8,
                              }}
                              className="insta transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:duration-300 "
                           />
                        </a>
                        {/* </div> */}

                        {/* <div className="h-8 w-8 rounded-full bg-black flex justify-center items-center"> */}
                        <a>
                           <FaSquareXTwitter
                              style={{
                                 color: '#000000',
                                 // color: 'white',
                                 fontSize: '25px',
                                 // marginRight: 8,
                              }}
                              className="transition ease-in-out delay-150  "
                           />
                        </a>
                        {/* </div> */}
                     </div>
                  </div>
                  <div className="flex gap-4 mt-4 font-semibold font-quicksand text-base text-[#0A142F]">
                     <Link to="/privacy-policy">Privacy policy</Link>
                     <Link to="/terms-of-use">Terms of use</Link>
                     <Link to="/booking-terms"> Booking & Purchase term</Link>
                  </div>
                  <div className="mt-4 font-semibold font-quicksand text-base text-[#0A142F]">
                     <Link
                        to="/login"
                        // onClick={() => setVisible(!visible)}
                        className="font-semibold text-[#0168FF] "
                     >
                        <span className="text-[#000000] font-semibold font-quicksand text-base mr-2">
                           Admin/Garage Login?
                        </span>
                        Login
                     </Link>
                  </div>
               </div>
            </div>
            <div className=" text-center">
               <p className=" text-base font-semibold font-quicksand pt-6 text-[#0A142F]">
                  ©{year} Inspectthiscar. All rights reserved
               </p>
            </div>
         </Container>
      </div>
   );
};

export default Footer;
